// extracted by mini-css-extract-plugin
export default {"root":"BaseModal_root__IVR+6","header":"BaseModal_header__+6xIH","body":"BaseModal_body__aRgHd","closeButton":"BaseModal_closeButton__omcBp"};